var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-project-diagram"}),_vm._v(" Contacts Apps")]),_c('div',{staticClass:"controls"},[_c('nav-tabs',{attrs:{"tabs":[
					{
						icon: 'fa-project-diagram',
						label: 'Contacts',
						path: '/contacts'
					},
					{
						icon: 'fa-tractor',
						label: 'All Assets',
						path: '/contact-assets'
					}
				],"addon-apps-location":"Contacts Module","addon-apps-link":"/contacts/apps"}})],1)]),_c('addon-app-tab',{attrs:{"ui-location":"Contacts Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }